export enum StepsTypes {
  ErrorView = -1,
  VehicleSelection,
  VehicleInfo,
  ConditionOverview,
  VehicleOwnership,
  CustomerInfo,
  OnlineEstimate,
  MonkConfirmation,
  OfferPage,
  UploadPhotos,
  UploadPhotosText,
  DisclosureSMS,
}

export enum OfferTypes {
  Success = 'success',
  MaxLimit = 'maxLimit',
  Redirect = 'redirect',
}
